










import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DadosEstadoComponente extends Vue {
    get estadocomponente () {
        return this.$store.state.cotacao.estadocomponente;
    }

    set estadocomponente ( value ) {
        this.$store.commit("SET_ESTADOCOMPONENTE", value);
    }

    get errorEstadoComponente () {
        return this.$store.state.errors.estadocomponente;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
